import { EnvironmentConfig } from 'relay-runtime/lib/store/RelayModernEnvironment';
import type { TMicroApps } from '../Auth';

export enum REMOTE_TYPES {
  ADMIN = 'ADMIN',
  LEARNER = 'LEARNER',
  BOTH = 'BOTH',
}

export type TOtherRemotesConfig = {
  remoteName: string;
  moduleName: string;
  host: string;
  blacklistedRoutes?: RegExp[];
};

export type TMicroAppDetails = {
  appName: TMicroApps;
  streamName: string;
  path?: string;
  remoteName: string;
  moduleName?: string;
  host?: string;
  enableRedux?: boolean;
  graphqlEndpoint?: string;
  collectorUrl?: string;
  layout?: boolean;
  isPublic?: boolean;
  isProtected?: boolean;
  isShareable?: boolean;
  enableSubscription?: boolean;
  remoteType: REMOTE_TYPES;
  children: TMicroAppDetails[];
  parentElement?: React.FC<any>;
  otherRemotesConfig?: TOtherRemotesConfig;
};

export type TestingRouteProps = {
  TestingApplication: () => JSX.Element;
  testingRoute: string;
  graphqlEndpoint?: string;
  collectorUrl?: string;
  enableRedux?: boolean;
  enableDatadog: boolean;
  isProtected: boolean;
  layout?: boolean;
  enableSubscription?: boolean;
  environmentOptions?: EnvironmentConfig;
};

export type TAppRoute = TMicroAppDetails & { element: JSX.Element };

export interface TRoutes {
  protectedRoutes: TAppRoute[];
  publicRoutes: TAppRoute[];
  shareableRoutes: TAppRoute[];
}

export type TMicroAppDetailsWithChildren = {
  appName: TMicroApps;
  streamName: string;
  path?: string;
  remoteName: string;
  moduleName?: string;
  host?: string;
  enableRedux?: boolean;
  graphqlEndpoint?: string;
  collectorUrl?: string;
  layout?: boolean;
  isPublic?: boolean;
  isProtected?: boolean;
  isShareable?: boolean;
  enableSubscription?: boolean;
  remoteType: REMOTE_TYPES;
  children: TMicroAppDetails[] | TRoutes;
  parentElement?: React.FC<any>;
};

export type TRoutesWithChildren = {
  protectedRoutes: TMicroAppDetailsWithChildren[];
  publicRoutes: TMicroAppDetailsWithChildren[];
  shareableRoutes: TMicroAppDetailsWithChildren[];
};
